import { Card } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledCard = styled(Card) `
  width: 100%;
`;
